import styled, { css } from "styled-components";
import { toRem } from "../../shared/toRem";
import { colors } from "../../shared/colors";
const headline = css `
  font-family: "RadionA";
  text-transform: uppercase;
  font-weight: 500;
  margin: 0;
  letter-spacing: 0;
`;
const desktopH1 = css `
  ${headline}
  font-size: ${toRem(72)};
  line-height: ${66 / 72};
`;
const desktopH2 = css `
  ${headline}
  font-size: ${toRem(48)};
  line-height: ${44 / 48};
`;
const desktopH3 = css `
  ${headline}
  font-size: ${toRem(26)};
  line-height: ${28 / 26};
`;
const desktopH4 = css `
  ${headline}
  font-size: ${toRem(20)};
  line-height: ${22 / 20};
`;
const mobileH1 = css `
  ${headline}
  font-size: ${toRem(48)};
  line-height: ${44 / 48};
`;
const mobileH2 = css `
  ${headline}
  font-size: ${toRem(34)};
  line-height: ${32 / 34};
`;
const mobileH3 = css `
  ${headline}
  font-size: ${toRem(22)};
  line-height: ${22 / 22};
`;
const mobileH4 = css `
  ${headline}
  font-size: ${toRem(18)};
  line-height: ${20 / 18};
`;
const text = css `
  font-family: TT Norms Pro;
  letter-spacing: 0;
`;
const b1BodyCopy = css `
  ${text}
  font-size: ${toRem(18)};
  line-height: ${28 / 18};
  font-weight: 500;
`;
const b2BodyCopy = css `
  ${text}
  font-size: ${toRem(14)};
  line-height: ${20 / 14};
  font-weight: 500;
`;
const b3BodyCopy = css `
  ${text}
  font-size: ${toRem(12)};
  line-height: ${14 / 12};
  font-weight: 700;
`;
const b4BodyCopy = css `
  ${text}
  font-size: ${toRem(12)};
  line-height: ${14 / 12};
  font-weight: 500;
`;
const label1 = css `
  ${text}
  text-transform: uppercase;
  font-size: ${toRem(18)};
  line-height: ${22 / 18};
  font-weight: 700;
  letter-spacing: 0.08em;
`;
const label2 = css `
  ${text}
  text-transform: uppercase;
  font-size: ${toRem(14)};
  line-height: ${16 / 14};
  font-weight: 700;
  letter-spacing: 0.08em;
`;
const label3 = css `
  ${text}
  text-transform: uppercase;
  font-size: ${toRem(12)};
  line-height: ${16 / 12};
  font-weight: 700;
  letter-spacing: 0.08em;
`;
const label4 = css `
  ${text}
  text-transform: uppercase;
  font-size: ${toRem(10)};
  line-height: ${12 / 10};
  font-weight: 700;
  letter-spacing: 0.08em;
`;
const label5 = css `
  ${text}
  text-transform: uppercase;
  font-size: ${toRem(6)};
  line-height: 1;
  font-weight: 700;
  letter-spacing: 0.08em;
`;
const navigation = css `
  ${text}
  text-transform: uppercase;
  font-size: ${toRem(12)};
  line-height: ${16 / 12};
  font-weight: 700;
  letter-spacing: 0.24em;
`;
// Subheading
const subheading1 = css `
  ${text}
  line-height: ${30 / 26};
  font-size: ${toRem(30)};
  font-weight: 500;
`;
const subheading2 = css `
  ${text}
  line-height: ${26 / 26};
  font-size: ${toRem(26)};
  font-weight: 500;
`;
const subheading3 = css `
  ${text}
  line-height: ${20 / 20};
  font-size: ${toRem(20)};
  font-weight: 500;
`;
const subheading4 = css `
  ${text}
  line-height: ${14 / 14};
  font-size: ${toRem(14)};
  font-weight: 500;
`;
const variants = {
    desktopH1,
    desktopH2,
    desktopH3,
    desktopH4,
    mobileH1,
    mobileH2,
    mobileH3,
    mobileH4,
    b1BodyCopy,
    b2BodyCopy,
    b3BodyCopy,
    b4BodyCopy,
    label1,
    label2,
    label3,
    label4,
    label5,
    navigation,
    subheading1,
    subheading2,
    subheading3,
    subheading4,
};
export const StyledComponent = styled.span `
  ${(props) => variants[props.variant]}
  ${(props) => props.align &&
    css `
      text-align: ${props.align};
    `}
  color: ${(props) => colors[props.$color]};
  padding: 0;
  margin: 0;
  pointer-events: ${(props) => (props.as === "label" ? "auto" : "none")};
  cursor: ${(props) => (props.as === "label" ? "pointer" : "inherit")};
`;
//# sourceMappingURL=styled.js.map